import { StoreState } from "../store";

export const dontUnselectSeatsPrompt = (seats: StoreState["seats"] = []) => {
  return (
    seats?.length &&
    !window.confirm(
      "This action will clear your current seat selection. Do you want to continue?"
    )
  );
};
